<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <!--          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="多语言类型">
              <a-input placeholder="请输入多语言类型" v-model="queryParam.langType"></a-input>
            </a-form-item>
          </a-col>-->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <mtc-form-item label="label.languageDescription">
              <a-input :placeholder="$t('label.pleaseEnterLanguageDescription')" v-model="queryParam.langText"></a-input>
            </mtc-form-item>
          </a-col>
          <!--          <template v-if="toggleSearchStatus">-->
          <!--            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="关联业务类型">
                <a-input placeholder="请输入关联业务类型" v-model="queryParam.relBizType"></a-input>
              </a-form-item>
            </a-col>-->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <mtc-form-item label="label.associatedDatabaseTable">
              <a-input :placeholder="$t('label.pleaseEnterAssociatedDatabaseTable')" v-model="queryParam.relTable"></a-input>
            </mtc-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <mtc-form-item label="label.associatedDataField">
              <a-input :placeholder="$t('label.pleaseEnterAssociatedDataField')" v-model="queryParam.relField"></a-input>
            </mtc-form-item>
          </a-col>
          <!--          </template>-->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <!--<a-button type="primary" @click="searchQuery" icon="search">查询</a-button>-->
              <!--<a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>-->
              <mtc-button @click="searchQuery" type="primary" icon="search"  text="button.search"></mtc-button>
              <mtc-button @click="searchReset" type="primary" icon="reload"  style="margin-left: 8px" text="button.reset"></mtc-button>
              <!--              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!--<a-button @click="handleAdd" type="primary" icon="plus">{{ $t('button.add') }}</a-button>-->
      <mtc-button @click="handleAdd" type="primary" icon="plus"  text="button.add"></mtc-button>
      <!--<a-button type="primary" icon="download" @click="handleExportXls('多语言国际化')">{{-->
        <!--$t('button.export')-->
      <!--}}</a-button>-->
      <mtc-button @click="handleExportXls('多语言国际化')" type="primary" icon="download"  text="button.export"></mtc-button>
      <a-upload
        name="file"
        :showUploadList="false"
        :multiple="false"
        :headers="tokenHeader"
        :action="importExcelUrl"
        @change="handleImportExcel"
      >
        <!--<a-button type="primary" icon="import">{{ $t('button.import') }}</a-button>-->
        <mtc-button type="primary" icon="import"  text="button.import"></mtc-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete" />{{ $t('button.delete') }}</a-menu-item>
        </a-menu>
        <!--<a-button style="margin-left: 8px"> {{ $t('button.batchOperation') }} <a-icon type="down" /></a-button>-->
        <mtc-button    style="margin-left: 8px" text="button.batchOperation"></mtc-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('tip.selected') }}
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >{{ $t('tip.term') }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('button.clear') }}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :scroll="{ x: true }"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >

        <template v-for="(item, index) in columns" :slot="item.slotName">
          <!--<span :key="index">{{ $t(item.slotName) }}</span>-->
          <mtcHeader :key="index" :text="item.slotName" />
        </template>

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>

        <span slot="action" slot-scope="text, record">
          <!--<a @click="handleEdit(record)">{{ $t('button.edit') }}</a>-->
          <mtc-button @click="handleEdit(record)" type="link" size="small" text="button.edit"></mtc-button>
          <a-divider type="vertical" />
          <a-dropdown>
            <!--<a class="ant-dropdown-link">{{ $t('button.more') }} <a-icon type="down" /></a>-->
                        <mtc-button  type="link" size="small" text="button.more"></mtc-button>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
                  <!--<a>{{ $t('button.delete') }}</a>-->
                  <mtc-button type="link" size="small" text="button.delete"></mtc-button>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <sysLanguage-modal ref="modalForm" @ok="modalFormOk"></sysLanguage-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import SysLanguageModal from './modules/SysLanguageModal'
import { MTC_AUTH } from '@api/servers'

export default {
  name: 'SysLanguageList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    SysLanguageModal,
  },
  data() {
    return {
      description: '多语言国际化管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          slotName: 'label.languageDescription',
          // title: '多语言描述',
          align: 'center',
          width: '300px',
          dataIndex: 'langText',
          scopedSlots: { title: 'label.languageDescription'}
        },
        {
          slotName: 'label.associatedBusinessType',
          // title: '关联业务类型',
          align: 'center',
          dataIndex: 'relBizType',
          scopedSlots: { title: 'label.associatedBusinessType'}
        },
        {
          slotName: 'label.associatedDatabaseTable',
          // title: '关联数据库表',
          align: 'center',
          dataIndex: 'relTable',
          scopedSlots: { title: 'label.associatedDatabaseTable'}
        },
        {
          slotName: 'label.associatedDataField',
          // title: '关联数据字段',
          align: 'center',
          dataIndex: 'relField',
          scopedSlots: { title: 'label.associatedDataField'}
        },
        {
          slotName: 'label.associatedEntityField',
          // title: '关联实体字段',
          align: 'center',
          dataIndex: 'relEntityAttribute',
          scopedSlots: { title: 'label.associatedEntityField'}
        },
        {
          slotName: 'tableHeader.whetherValid',
          // title:'是否有效',
          align:"center",
          dataIndex: 'validFlag_dictText',
          scopedSlots: { title: 'tableHeader.whetherValid'}
        },
        {
          slotName: 'tableHeader.operation',
          // title: '操作',
          dataIndex: 'action',
          scopedSlots: {customRender: 'action', title: 'tableHeader.operation'},
          align: "center",
          width: 170
        },
      ],
      url: {
        list: `${MTC_AUTH}system/sysLanguageDisposition/list`,
        delete: `${MTC_AUTH}system/sysLanguageDisposition/setDeleteFlag`,
        deleteBatch: `${MTC_AUTH}system/sysLanguageDisposition/deleteBatch`,
        exportXlsUrl: `${MTC_AUTH}system/sysLanguageDisposition/exportXls`,
        importExcelUrl: `${MTC_AUTH}system/sysLanguageDisposition/importExcel`,
      },
      dictOptions: {},
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    initDictConfig() {},
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>